// @flow
import type { Banner } from "../../../../app/scripts/tools/banner.types"

type SetBanner = {|
  type: "SET_BANNERS",
  payload: { banners: Array<Banner>, showOnMobile: boolean },
|}
type SetChatModal = {|
  type: "SET_CHAT_MODAL",
  payload: { text: string },
|}
type SetDelayedChat = {|
  type: "SET_DELAYED_CHAT",
  payload: {
    chatEnabled: boolean,
    titleText: string | null,
    recoverText: string | null,
    alternativeContactText: string | null,
    alternativeContactLinkText: string | null,
    alternativeContactLinkAddress: string | null,
  },
|}
type RemoveBanner = {|
  type: "REMOVE_BANNER",
  payload: { index: number },
|}

export type Action = SetBanner | SetChatModal | SetDelayedChat | RemoveBanner

export const setBanner = (banners: Array<Banner>, showOnMobile: boolean): SetBanner => ({
  type: "SET_BANNERS",
  payload: { banners, showOnMobile },
})

export const removeBanner = (index: number): RemoveBanner => ({
  type: "REMOVE_BANNER",
  payload: { index },
})

export const setChatModal = (text: string): SetChatModal => ({
  type: "SET_CHAT_MODAL",
  payload: { text },
})

export const setDelayedChat = (
  chatEnabled: boolean,
  titleText: string | null,
  titleTextTranslation: string | null,
  recoverText: string | null,
  alternativeContactText: string | null,
  alternativeContactLinkText: string | null,
  alternativeContactLinkAddress: string | null,
): SetDelayedChat => ({
  type: "SET_DELAYED_CHAT",
  payload: {
    showDelayedChat: true,
    chatEnabled,
    titleText,
    titleTextTranslation,
    recoverText,
    alternativeContactText,
    alternativeContactLinkText,
    alternativeContactLinkAddress,
  },
})
